import { IModuleProps } from '../core/utils/modules';

import routes from './routes';

export default {
    name: 'customer',
    routes,
} as IModuleProps;
